var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-switch"},[_c('el-color-picker',{staticClass:"theme-picker",attrs:{"popper-class":"theme-picker-dropdown"},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }